import { useEffect, useState } from "react";
import { LoadingStateWithIdle, LoadingStateWithIdleOps } from "../../../domain/data-layer/loading-state-with-idle";
import { useMountedRef } from "../../use-mounted";

export function useGoogleMap(API_KEY: string) {
  const [state, setState] = useState<LoadingStateWithIdle<string>>(LoadingStateWithIdleOps.idleS);
  const mountedRef = useMountedRef();

  useEffect(() => {
    const id = `google-map-ref`;

    if (document.querySelector(`#${id}`) || (window as any)?.google?.maps) {
      // console.log("Attempted to reinitialize google maps");
      return;
    }

    setState(LoadingStateWithIdleOps.loadingS);

    let scriptEl = document.createElement("script");
    scriptEl.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=geometry,places`;
    scriptEl.defer = true;
    scriptEl.async = true;
    scriptEl.id = id;
    scriptEl.onerror = e => {
      if (mountedRef.current) {
        setState(LoadingStateWithIdleOps.asFailed(e));
      }
    };

    scriptEl.onload = () => {
      // console.log("on load");
      if (mountedRef.current) {
        setState(LoadingStateWithIdleOps.asLoaded(id));
      }
    };

    document.body.appendChild(scriptEl);

    return () => {
      // console.log(`Cleanup ${id2}`);
      document.body.removeChild(scriptEl);

      if ("google" in window && "maps" in window.google) {
        delete (window as any).google.maps;
      }
    };
  }, [API_KEY]);

  return state.__tag === "loaded";
}
